import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'This data is not supported for Savings accounts',
  description:
    'Please select a different account to view a breakdown of your transactions by category and contact.',
})
